/* eslint-disable no-redeclare */
/* global window, chrome */
import { config } from '../constants/config_constants';

const CHROME_ID = config.chrome_ext_id;
class ChromeExtensionService {

    static sendMessage(messageJSON, responseCallback) {
        /* eslint-disable no-prototype-builtins */
        if (window.hasOwnProperty('chrome') && typeof chrome.runtime !== 'undefined') {
            chrome.runtime.sendMessage(CHROME_ID, messageJSON, responseCallback);
        }
        else {
            return responseCallback();
        }
    }
}

export default ChromeExtensionService;


// WEBPACK FOOTER //
// ./src/services/ChromeExtensionService.js